<template>
  <v-container class="pa-0">
    <!-- <v-tooltip bottom>
      <template v-slot:activator='{ on, attrs }'>
        <v-btn
          class='mx-2'
          fab
          dark
          small
          v-bind='attrs'
          v-on='on'
          color='yellow'
          :loading='saleInvLoading'
          @click='download'
        >
          <v-icon dark>mdi-package-down</v-icon>
        </v-btn>
      </template>
<span>Export</span>
</v-tooltip> -->
    <download-excel class="primary--color" :fetch="getsaleInv" worksheet="untitled"
                    :title="`Sale Inventory ${storeName}`" type="xls"
                    :name="`${storeName}_sale_inventory_${new Date().getTime()}.xls`" :fields="getFields()">
      <v-btn text block :loading="this.saleInvLoading" color="primary">
        Export XLS
      </v-btn>
    </download-excel>
    <alert-success :toggle-dialog="success" title="Import Success" message="Data was Exported successfully" />
    <alert-error :toggle-dialog="error" title="Import Error!" :message="saleInvErrors" />
  </v-container>
</template>
<script>
import { errorHandler } from '@/extra-functions/store.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'
import saleInvRepository from '@/repositories/sale-inventory.repository'
import { mapState } from 'vuex'

const errorDelay = searchDelay(100)

const inputVars = () => ({
  saleInvList: [],
  saleInvErrors: [],
  saleInvLoading: false,
  success: false,
  error: false,
})

export default {
  name: 'ExportLostInventories',
  components: {
    alertSuccess: () => import('@/views/dashboard/components/AlertSuccess'),
    alertError: () => import('@/views/dashboard/components/AlertError'),
  },
  data() {
    return {
      ...inputVars(),
    }
  },
  created() {
  },
  computed: {
    ...mapState({
      storeId: state => state.settings.storeId,
      stores: state => state.branchLocation.list,
    }),
    storeName() {
      return this.stores.find(e => e.id === this.storeId).name
    },
  },
  methods: {
    writeExcel(filePath) {
      return ({ data }) => {
        this.saleInvList = data
        // writeExcel(filePath, `inventory-purchases_${new Date().getTime()}`, data)
        // this.success = true
        // successDelay(() => { this.success = false })
      }
    },
    getFields() {
      return {
        'receipt no': 'receipt_no',
        'stock code': 'stock_code',
        'brand name': 'brand_name',
        Consumer: 'consumer_name',
        description: 'description',
        'product name': 'product_name',
        'supplier id': {
          field: 'supplier_id',
          callback: value => `'${value}`,
        },
        'supplier name': 'supplier_name',
        retail: {
          field: 'retail',
          callback: value => `${value.toFixed(2)}`,
        },
        quantity: {
          field: 'quantity',
          callback: value => `${value.toFixed(2)}`,
        },
        unit: 'unit',
        'total amount': {
          field: 'total_amount',
          callback: value => `${value.toFixed(2)}`,
        },
        'date Sold': 'date_sold',
      }
    },
    async getsaleInv(filePath) {
      if (this.saleInvLoading) return
      this.saleInvLoading = true
      const { storeId } = this.$store.state.settings
      try {
        const response = await saleInvRepository.storeIndexAll(storeId)
          .catch(this.getInvRcvErr)
        this.saleInvLoading = false
        return await response.data
      } catch (e) {

      }
      // .then(() => {})
      // .then(() => { this.saleInvLoading = false })
    },
    getInvRcvErr(e) {
      this.error = true
      errorDelay(() => { this.error = false })
      this.saleInvErrors = errorHandler(e)
    },
  },
}
</script>
